import useAsyncData from "../../../../hooks/use-async-data";
import driverService from "../../../driver/driver.service";
import userService from "../../user.service";
import UserDriverEditForm from "./user-driver-edit-form";
import UserDriverEditFormParams from "./user-driver-edit-form-params";

const useDriverEditForm = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserDriverEditForm | null>(null);

  const load = async (
    params: UserDriverEditFormParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const driverEditForm = await userService.getDriverEditForm(
        params,
        signal,
      );

      setData(driverEditForm);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDriverEditForm;
